import { Grid, Typography, Checkbox } from '@mui/material'
import React from 'react'

export default function PortfolioAccount({
  name,
  accountType,
  subAccountsCount = 0,
  isAccountInPortfolio = false,
  onCheckboxChanged,
  disabled = false,
}) {
  return (
    <Grid container alignItems={'center'}>
      <Grid item>
        <Checkbox
          edge="start"
          checked={isAccountInPortfolio}
          disableRipple
          disabled={disabled}
          onChange={(e) => {
            onCheckboxChanged(e.target.checked)
          }}
        />
      </Grid>
      <Grid item>
        <Typography color={disabled ? 'secondary' : null}>
          {name} {accountType} {subAccountsCount > 0 && `(${subAccountsCount})`}
        </Typography>
      </Grid>
    </Grid>
  )
}
